import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import {cls, Row, Column, Button,} from '../../packages/components';
import './styles/modalRememberConfirmPurchase.scss';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import { showConfirmPurchase60Seconds, showLimiteIntentos } from '../../payments/utils/Utils';
import { send2FA } from '../../requests/loader';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY } from '../../AAFPlayer/constants';
import timerManager, { MINUTES_TO_HELP } from '../../2FA/TimerManager';
import Utils, { minutesToMiliseconds } from '../../utils/Utils';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import ResendCodeButton2FA from '../ResendCodeButton2FA/ResendCodeButton2FA';
import { pausePlayer } from '../../2FA/callbacks';

const MAIN_CLASSNAME = 'modal-remember-confirm';
const MAIN_TEXTNAME_CLASSNAME = 'aaf_text-remember-confirm';
const TEXT_KEYS = {
  title: 'Alerta_2FATelmex_RecordatorioCompra_TextoTitulo',
  oneTextPhoneAndEmail1: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte1',
  oneTextPhoneAndEmail2: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte2',
  oneTextPhoneAndEmail3: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte3',
  oneTextPhoneAndEmail4: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte4',
  oneTextPhoneAndEmail5: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte5',
  oneTextPhoneAndEmail6: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Parte6',
  oneTextPhone1: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Telefono_Parte1',
  oneTextPhone2: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Telefono_Parte2',
  oneTextPhone3: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Telefono_Parte3',
  oneTextPhone4: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Telefono_Parte4',
  oneTextEmail1: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Correo_Parte1',
  oneTextEmail2: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Correo_Parte2',
  oneTextEmail3: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Correo_Parte3',
  oneTextEmail4: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje1_Correo_Parte4',
  infoText1: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje2_Parte1',
  infoText2: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje2_Parte2',
  infoText3: 'Alerta_2FATelmex_RecordatorioCompra_TextoMensaje2_Parte3',
  helpTitle: 'Alerta_2FATelmex_TextoTituloAyuda',
  helpText1: 'Alerta_2FATelmex_RecordatorioCompra_TextoAyuda1',
  helpText2: 'Alerta_2FATelmex_RecordatorioCompra_TextoAyuda2',
  button: 'Alerta_2FATelmex_TextoBotonPrimario_Reenviar',
  icon: 'Alerta_2FATelmex_Icono_Alerta'
};

class AAFModalRememberConfirmPurchase extends Component {
  constructor(props) {
    super(props);
    const dataBuyconfirm = JSON.parse(localStorage.getItem('buyConfirmData'));
    this.dataBuyconfirm = dataBuyconfirm
    this.getSend2fa = this.getSend2fa.bind(this);
  }

  componentDidMount() {
    const regionaliazedData = Utils.getRegionaliazedMetadata('2fa_config');
    const minutesToHelpRegionalizazed = regionaliazedData && regionaliazedData.minutes_to_help;
    timerManager.setDuration(MINUTES_TO_HELP, minutesToMiliseconds(minutesToHelpRegionalizazed));
  }

  componentWillUnmount() {
  }

  getContentText = (key) => {
    const translation = Translator.get(key)
    if(translation === "" || translation === undefined){
      return key
    } else if(translation === null){
      return '\u00A0'
    }else{
      return translation
    }  
  }

  getOneText = (phone, email) => {
    if(phone && email){
      return (
        <div>
          <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
            {this.getContentText(TEXT_KEYS.oneTextPhoneAndEmail1)}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{this.getContentText(TEXT_KEYS.oneTextPhoneAndEmail2)}</span>{' '}
            {this.getContentText(TEXT_KEYS.oneTextPhoneAndEmail3)}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{phone}</span>{' '}
            {this.getContentText(TEXT_KEYS.oneTextPhoneAndEmail5)}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{email}</span>
          </p>
        </div>
      )
    } else if(phone && !email){
      return(    
        <div>
            <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
              {this.getContentText(TEXT_KEYS.oneTextPhone1)}{' '}
              <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{this.getContentText(TEXT_KEYS.oneTextPhone2)}</span>{' '}
              {this.getContentText(TEXT_KEYS.oneTextPhone3)}{' '}
              <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{phone}</span>
            </p>
          </div>
      )
    } else if(!phone && email){
      return(
        <div>
          <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>
            {this.getContentText(TEXT_KEYS.oneTextEmail1)}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{this.getContentText(TEXT_KEYS.oneTextEmail2)}</span>{' '}
            {this.getContentText(TEXT_KEYS.oneTextEmail3)}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{email}</span>
          </p>
        </div>
      )
    }
  };

  getIconImage = (icon) => {
    const infoIcon = Asset.get(icon);
    return infoIcon;
  }

  getSend2fa = async () => {
    const send2faURL = this.dataBuyconfirm.send2fa;
    const transactionId = this.dataBuyconfirm.transactionId;
    const resp = await send2FA({send2faURL, transactionId});
  }

  handleClick = async (e) => {
    const countResend = DeviceStorage.getItem("count_2FA");
    const maxNumResend = DeviceStorage.getItem("max_num_resend_2FA");
    if(countResend >= maxNumResend){
      showLimiteIntentos();
      pausePlayer()
    } else {
      await this.getSend2fa();
      timerManager.deleteTimer(this.dataBuyconfirm.transactionId, MINUTES_TO_HELP);
      localStorage.setItem('ModalRemember', "true");
      showConfirmPurchase60Seconds(this.dataBuyconfirm);
    }
  };

  handleBack = () => {
    this.props.callbackWhenBack()
  }
  
  render(){
    const phone = this.dataBuyconfirm.phone;
	  const email = this.dataBuyconfirm.mail;

    return (
      <ModalWrapper className="aaf_app_modal-remember-confirm" callbackWhenBack={this.handleBack}>
        <div className={`${MAIN_CLASSNAME} FullHD`}>
          <Row className={cls(`${MAIN_CLASSNAME} divTitle`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} title`)}>
                {this.getContentText(TEXT_KEYS.title)}
              </p>
            </Column>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divOneText`)}>
            {this.getOneText(phone, email)}
          </Row>
          <div className={cls(`${MAIN_CLASSNAME} divInfo`)}>
            <div className='container-divInfo'>
              <div className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoImg`)}>
                <img className={cls(`${MAIN_CLASSNAME} imgInfo`)} src={this.getIconImage(TEXT_KEYS.icon)} alt={this.getIconImage()} />
                <div className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoText`)}>
                  <p>{this.getContentText(TEXT_KEYS.infoText1)}</p>&nbsp;
                  <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{this.getContentText(TEXT_KEYS.infoText2)}</p>&nbsp;
                  <p>{this.getContentText(TEXT_KEYS.infoText3)}</p>
                </div>
              </div>
            </div>
          </div>
          <Row className={cls(`${MAIN_CLASSNAME} divButton`)}>
            <ResendCodeButton2FA
              label={this.getContentText(TEXT_KEYS.button)}
              classname={cls(`${MAIN_TEXTNAME_CLASSNAME} primaryButton focusable`)}
              onClick={this.handleClick}
              startDisabled={false}
            />
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divTitleHelp`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} titleHelp`)}>
                {this.getContentText(TEXT_KEYS.helpTitle)}
              </p>
            </Column>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divTextHelp1`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
                {this.getContentText(TEXT_KEYS.helpText1)}   
              </p>
            </Column>
          </Row>
          <Row className={cls(`${MAIN_CLASSNAME} divTextHelp2`)}>
            <Column lg={12}>
              <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
                {this.getContentText(TEXT_KEYS.helpText2)}  
              </p>
            </Column>
          </Row>
        </div>
      </ModalWrapper>
    );
  }
}


AAFModalRememberConfirmPurchase.defaultProps = {
  callbackWhenBack: () => {},
};

export default withOnClose(AAFModalRememberConfirmPurchase);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalRememberConfirmPurchase2FA.jsx